import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import './ArticlePage.css';
import { Helmet } from 'react-helmet';

const ArticlePage = () => {
  const { articleId } = useParams();
  const [isLoaded, setIsLoaded] = useState(false);
  
  useEffect(() => {
    // Add fade-in effect when component mounts
    setIsLoaded(true);
    
    // Scroll to top on component mount
    window.scrollTo(0, 0);
  }, [articleId]); // Re-run the effect if the article ID changes

  return (
    <>
      <Helmet>
        <title>{`${articleId} | Clarity Impact Finance`}</title>
        <meta name="description" content={`Read about ${articleId} at Clarity Impact Finance.`} />
      </Helmet>
      <Navbar />
      <div className={`article-page-container ${isLoaded ? 'fade-in' : ''}`}>
        <h1>Article: {articleId}</h1>
        <p>This is a placeholder for displaying article content with ID: {articleId}</p>
      </div>
      <Footer />
    </>
  );
};

export default ArticlePage; 